import { useTranslation } from 'src/lib/i18n/useTranslation';
import styles from './ErrorScreen.module.scss';

interface ErrorScreenProps {
  error?: any,
}

export function ErrorScreen(props: ErrorScreenProps) {
  const { t } = useTranslation();
  console.error('error', props.error);

  return (
    <div className={ styles.container }>
      <header className={ styles.header }>
        <h1 className={ styles.title }>
          { t('error_title') }
          </h1>
      </header>
      <div className={ styles.content }>
        { t('error_description') }
      </div>
    </div>
  );
}
